module.exports = __webpack_public_path__ + "static/media/Template - End sellout prices.90cb45c0.csv";